import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../enums/QueryKey';
import config from '../config';

const VERSION_DISMISSED_KEY = 'callmart-dismissed-build-hash';
const POLL_INTERVAL = 5 * 60 * 1000; // 5 minutes

type VersionInfo = {
    version: string;
    buildHash: string;
};

async function fetchServerVersion(): Promise<VersionInfo> {
    const response = await fetch(`${config.apiURL}/version`, {
        cache: 'no-store',
    });
    if (!response.ok) {
        throw new Error('Failed to fetch version');
    }

    return response.json() as Promise<VersionInfo>;
}

export default function useVersionCheck() {
    const [dismissedBuildHash, setDismissedBuildHash] = useState(() =>
        sessionStorage.getItem(VERSION_DISMISSED_KEY)
    );

    const { data: serverVersionInfo } = useQuery({
        queryKey: [QueryKey.AppVersion],
        queryFn: fetchServerVersion,
        refetchInterval: POLL_INTERVAL,
        refetchIntervalInBackground: true,
        retry: false,
    });

    const isNewVersionAvailable =
        !!serverVersionInfo &&
        serverVersionInfo.buildHash !== config.buildHash &&
        serverVersionInfo.buildHash !== dismissedBuildHash;

    const dismissUpdate = () => {
        if (serverVersionInfo) {
            sessionStorage.setItem(VERSION_DISMISSED_KEY, serverVersionInfo.buildHash);
            setDismissedBuildHash(serverVersionInfo.buildHash);
        }
    };

    const refreshPage = () => {
        window.location.reload();
    };

    return { isNewVersionAvailable, dismissUpdate, refreshPage };
}
